import { NSARouterMakerResult } from "namirasoft-account-react";
import { SupportEntities } from "../SupportEntities";
import { SupportLayout } from "../SupportLayout";
import { SupportProps } from "../SupportProps";
import TicketMessages from "../components/TicketMessages";

export interface TicketViewPageProps extends NSARouterMakerResult, SupportProps { }

function TicketViewPage(props: TicketViewPageProps)
{
    return (
        <SupportLayout
            {...props}
            action={{
                description: "This section lets you see the details of a submitted ticket, track its status, and follow the conversation with the support team."
            }}
            pages={{
                entity: SupportEntities.ticket(props),
                view: {
                    ui: {
                        getChildrenAfter: (_, row) => <TicketMessages row={row} />
                    }
                },
            }}
        >
            <></>
        </SupportLayout>
    );
}

export default TicketViewPage;